import React, { useEffect, useState } from "react";
import { Button, message, Upload, Spin, Tag } from "antd";
import { useAudioRecorder } from "react-audio-voice-recorder";
import { UploadOutlined, CheckCircleOutlined } from "@ant-design/icons";
import api from "../../api/api";

const VoiceRecorder = ({ onChange, initialMedia }) => {
  const { startRecording, stopRecording, isRecording, recordingBlob } =
    useAudioRecorder();

  const [audioURL, setAudioURL] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [uploaded, setUploaded] = useState(false);

  const baseUrl =
    window.location.hostname === "localhost"
      ? "http://localhost:1337"
      : window.location.hostname === "stageadmin.planium.ir"
      ? "https://stageapi.planium.ir"
      : window.location.hostname === "admin.planium.ir"
      ? "https://api.planium.ir"
      : "";

  // Set audio URL if initial media is provided
  useEffect(() => {
    if (initialMedia?.url) {
      setAudioURL(baseUrl + initialMedia.url);
    }
  }, [initialMedia]);

  // Function to upload the recorded audio file
  const uploadAudio = async (audioBlob) => {
    if (!audioBlob) return;

    const formData = new FormData();
    formData.append("uploadedFile", audioBlob, "voice.wav");

    setUploading(true);
    setUploaded(false);
    try {
      const response = await api.post("/media-manager/upload", formData);
      onChange("mediaId", response.data.id); // Pass media ID to parent component
      if (response.data.url) {
        onChange("voiceUrl", response.data.url);
        const url = new URL(response.data.url, baseUrl);
        setAudioURL(url.href);
      }
      setUploaded(true);
      message.success("آپلود انجام شد");
    } catch (err) {
      console.error("Error uploading audio", err);
      message.error("خطا در آپلود");
    } finally {
      setUploading(false);
    }
  };

  // Set audio URL and trigger upload when a recording is completed
  useEffect(() => {
    if (recordingBlob) {
      const url = URL.createObjectURL(recordingBlob);
      setAudioURL(url);
      uploadAudio(recordingBlob);
    }
  }, [recordingBlob]);

  const handleChange = ({ fileList }) => {
    if (fileList.length > 0 && !fileList[0].url) {
      handleUpload(fileList);
    }
  };

  const handleUpload = async (fileList) => {
    const formData = new FormData();
    if (fileList.length === 0) {
      return;
    }

    formData.append("uploadedFile", fileList[0].originFileObj);

    setUploading(true);
    setUploaded(false);
    try {
      const response = await api.post("/media-manager/upload", formData);
      onChange("mediaId", response.data.id);
      if (response.data.url) {
        onChange("voiceUrl", response.data.url);
        const url = new URL(response.data.url, baseUrl);
        setAudioURL(url.href);
      }
      setUploaded(true);
      message.success("آپلود انجام شد");
    } catch (err) {
      message.error("خطا در آپلود");
      console.error("Error uploading image", err);
    } finally {
      setUploading(false);
    }
  };

  return (
    <div>
      {!audioURL && !isRecording && (
        <Upload
          accept="audio/*"
          listType="text"
          fileList={[]}
          beforeUpload={() => false}
          maxCount={1} // Limit to one file
          onChange={handleChange}
          disabled={uploading}
        >
          <Button icon={<UploadOutlined />} disabled={uploading}>
            انتخاب فایل صوتی
          </Button>
        </Upload>
      )}

      {/* Start/Stop recording buttons */}
      {!audioURL && !isRecording && (
        <Button onClick={startRecording} disabled={uploading}>
          ضبط صدا
        </Button>
      )}

      {isRecording && <Button onClick={stopRecording}>اتمام ضبط</Button>}

      {uploading && (
        <div style={{ display: "flex", alignItems: "center", gap: "0.5rem", marginTop: "0.5rem" }}>
          <Spin size="small" />
          <span>در حال آپلود... لطفا صبر کنید</span>
        </div>
      )}

      {/* Show audio player when an audio URL is available */}
      {audioURL && (
        <>
          <audio
            style={{ width: "100%", marginTop: "1rem" }}
            controls
            src={audioURL}
          ></audio>
          {uploaded && !uploading && (
            <div style={{ marginTop: "0.5rem" }}>
              <Tag color="success" icon={<CheckCircleOutlined />}>
                تایید
              </Tag>
            </div>
          )}
          <Button
            danger
            style={{ marginTop: "0.5rem" }}
            disabled={uploading}
            onClick={() => {
              setAudioURL(null);
              setUploaded(false);
              onChange("mediaId", null);
              onChange("voiceUrl", "");
            }}
          >
            حذف صدا
          </Button>
        </>
      )}
    </div>
  );
};

export default VoiceRecorder;
